<template>
  <div :class="{ 'file-holder allow-list': recipientList.length }">
    <section v-if="recipientList.length">
      <!-- Recipient List dropdown -->
      <div class="list-dropdown">
        <MultipleRecipientListDropdown
          :class="{ isMuted: 'isMuted' }"
          :recipientList="recipientList"
          placeholder="Select Recipient List"
          :isGroupOrder="isGroupOrder"
          @handleSelection="data => (selectedLists = data)"
        />
      </div>

      <!-- Pill Section Here -->
      <AllowListPill
        :classes="'isMuted'"
        :selectedLists="selectedRecipient"
        :groupOrderDetails="groupOrderDetails"
      />

      <!-- Divider here -->
      <div class="justify-center flex">
        <div class="divider ">
          <p>or</p>
        </div>
      </div>
    </section>

    <FileUpload
      id="allow-list"
      :fileSupport="['CSV']"
      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      @fileChange="e => uploadList(e)"
      :isTransparent="true"
    />

    <!-- Allowed List Emails Here -->
    <div>
      <AllowList :groupOrderDetails="groupOrderDetails" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { progressStatus } from '../../../helpers'
import FileUpload from '@/components/Universal/FileUpload'
import MultipleRecipientListDropdown from '@/components/SendGiftFlow/MultipleRecipientListDropdown.vue'
import AllowList from '../AllowList.vue'
import AllowListPill from '../AllowListPill.vue'
export default {
  name: 'AllowListRecipientSelect',
  props: ['isGroupOrder', 'isMuted'],
  data() {
    return {
      customFields: []
    }
  },

  components: {
    MultipleRecipientListDropdown,
    FileUpload,
    AllowList,
    AllowListPill
  },
  methods: {
    addCustomField() {
      this.customFields.push({ name: '', type: 'text' })
    },
    uploadList(e) {
      const file = e.target.files[0]
      this.$store.dispatch('groupOrder/uploadAllowList', {
        type: 'file',
        id: this.groupOrderDetails.id,
        file: file
      })
    }
  },
  computed: {
    loadStatus() {
      return progressStatus(this.loadGroupOrder)
    },
    ...mapState({
      loadGroupOrder: state => state.groupOrder.loadGroupOrder,
      groupOrderDetails: state => state.groupOrder.groupOrderDetails,
      recipientList: state => state.recipient.recipientListRecords,
      selectedRecipient: state => state.recipient.selectedRecipientList
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';
.file-holder {
  margin: 1.5rem 0;
  border: 0.5px solid #979797;
  height: 88px;
  padding: 0.375rem 1rem;
  border-radius: 12px;

  &.allow-list {
    height: auto;
    padding: 0.75rem 1rem;
  }

  &.none {
    border: none;
  }

  .divider {
    color: #25282a;
    margin: 1.25rem 0;
    font-size: 0.875rem;
    position: relative;
    width: 300px;
    height: 50px;
    line-height: 50px;
    text-align: center;

    &::before,
    &::after {
      position: absolute;
      width: 130px;
      height: 1px;
      top: 25px;
      background-color: #979797;
      content: '';
    }

    &::before {
      left: 0;
    }

    &::after {
      right: 0;
    }

    p {
      text-align: center;
    }
  }
}
</style>
